module.exports = __webpack_public_path__ + "static/section_mainInfo_bg-31dda2e039ed0554afb3e4c353991fa3.png";